
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const CheckAuth = ({children}) => {
    const {token}=useSelector((state)=>state.AuthReducer);
    const navigate = useNavigate();
    if(!token){
        navigate('/')
    }
    return children
}

export default CheckAuth